export const RECIPIENT_DETAILS = 'RECIPIENT_DETAILS';
export const SENDER_DETAILS = 'SENDER_DETAILS';
export const PHONE_BOOK = 'PHONE_BOOK';
export const CALCULATOR = 'CALCULATOR';
export const PHONE_CALCULATOR = 'PHONE_CALCULATOR';
